import React, { Component } from 'react';
import {Select, Icon, Row, Col} from 'antd'
import './select.less'

export default class MultipleSelectSearch extends Component {

    constructor() {
        super();
        this.state = {
          selectedLenders: []
        }
    }

    componentDidMount() {
        this.setState({
            selectedLenders: this.props.mappedLenders
        })
    }

    handleDropdownChange = (value) => {
        this.setState({
            selectedLenders: [...value]
          })
        this.props.handleChange(this.props.productID, value)
    }

    render() {
        return (
            <Row className='select-search-container'>
                <Icon type="search" width='20px' className='search-icon-style'/>
                <Select
                showArrow="true"
                showSearch='true'
                mode="multiple"
                size='large'
                className='select-bar-style'
                placeholder={this.props.placeholder}
                onChange={this.handleDropdownChange}
                value={this.state.selectedLenders}
                menuItemSelectedIcon={<Icon type="check-square" theme="filled" />}
                optionFilterProp="children"
                filterOption={(input, option) =>  
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 
                  }
                 >
                {this.props.allOptions}
                </Select>
            </Row>
        );
    }
}